var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-5 mangerContractors" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.loading, hasData: _vm.isDataLoaded } },
        [
          _vm.isEmpty
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: { title: _vm.emptyListTitle },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageContractors")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    143841379
                  ),
                },
                [
                  !_vm.isManagerRole
                    ? _c("AddContractorToManager", {
                        staticClass: "flex justify-end",
                        attrs: {
                          companyId: _vm.companyId,
                          managerId: _vm.managerId,
                          currentUserId: _vm.currentUserId,
                          buttonSize: "xl",
                        },
                        on: {
                          contractorWasAddedToManager: _vm.refetchContractors,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "bg-white px-8 pt-6" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-row justify-between items-flex-start mb-4",
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "flex font-400 labelWidth leading-6 text-primary-black text-lg",
                          },
                          [
                            _vm._v(" Resources "),
                            _vm.managerContractors &&
                            _vm.managerContractors.length > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-gray-new text-base font-normal text-sm ml-0.5",
                                  },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.managerContractors.length) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex pb-1" },
                        [
                          _c("AddContractorToManager", {
                            staticClass: "flex justify-end",
                            attrs: {
                              companyId: _vm.companyId,
                              managerId: _vm.managerId,
                              currentUserId: _vm.currentUserId,
                            },
                            on: {
                              contractorWasAddedToManager:
                                _vm.refetchContractors,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap flex-row gap-4" },
                    _vm._l(
                      _vm.managerContractors,
                      function ({ contractor, id }) {
                        return _c(
                          "ContractorCard",
                          {
                            key: contractor.id,
                            attrs: {
                              avatar: contractor.user.avatar,
                              companyId: _vm.companyId,
                              companyNotifications:
                                contractor.user.company_notifications,
                              contractorId: contractor.id,
                              contractorUserId: contractor.user.id,
                              status: contractor.status,
                              currentUser: _vm.currentUser,
                              currentUserId: _vm.currentUser.id,
                              currentUserRole: _vm.currentUser.role,
                              currency: contractor.user.profile.currency,
                              familyName: contractor.user.family_name,
                              favorited: contractor.user.favorited_by_users,
                              tag: contractor.tag,
                              givenName: contractor.user.given_name,
                              jobTitle: _vm.getOccupation(contractor),
                              companyName: contractor.user.profile.company_name,
                              location: _vm.getLocation(
                                contractor.user.profile
                              ),
                              managers: contractor.managers,
                              maxRate: contractor.user.profile.max_rate,
                              minRate: contractor.user.profile.min_rate,
                              skills: contractor.user.profile.skills,
                              emailConfirmed: contractor.user.confirmed,
                              userUpdatedDate: contractor.user.updated_at,
                              contractors: [contractor],
                              absoluteDetailsLinkPath: "",
                            },
                            on: {
                              message: _vm.message,
                              refetch: _vm.refetchContractors,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "rating",
                                  fn: function () {
                                    return [
                                      _c("ContractorRating", {
                                        staticClass:
                                          "flex items-center justify-center w-full mt-4 mb-1",
                                        attrs: {
                                          ratingTotal: contractor.ratingTotal,
                                          ratingCount:
                                            contractor.ratingTotal.aggregate
                                              .count,
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                !_vm.isManagerRole
                                  ? {
                                      key: "actions",
                                      fn: function () {
                                        return [
                                          _c("RemoveAccessToContractor", {
                                            staticClass: "w-full",
                                            attrs: {
                                              managerContractorId: id,
                                              contractorFullName:
                                                _vm.getContractorFullName(
                                                  contractor
                                                ),
                                            },
                                            on: {
                                              accessRemoved:
                                                _vm.refetchContractors,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "v-else",
                              [
                                _c("AddContractorToCompany", {
                                  attrs: {
                                    buttonText: "Request access",
                                    buttonSize: "no",
                                    buttonVariant: "linkButton",
                                    contractorId: id,
                                    currentUserRole: _vm.currentUser.role,
                                    currentUserId: _vm.currentUser.id,
                                    companyId: _vm.companyId,
                                    companyName:
                                      contractor.user.profile.company_name,
                                    contractorUserId: contractor.user.id,
                                  },
                                  on: {
                                    addedToCompany: function ($event) {
                                      return _vm.$emit("contractorAdded")
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                  _c("CardPagination", {
                    attrs: { config: _vm.paginationConfig },
                    on: {
                      "update:config": function ($event) {
                        _vm.paginationConfig = $event
                      },
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }